import { SYSTEM_ROLE_NAMES } from '@/constants';
import { useAuth } from '@/hooks/useAuth.tsx';
import { getUserRole } from '@/utils';

export const useIsAdminRole = () => {
  const token = useAuth().user?.access_token;
  const isAdmin = getUserRole(token ?? '') === SYSTEM_ROLE_NAMES.ADMINISTRATORS;

  return { isAdmin };
};
